import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface ListInquiryFooterButtonGroupProps {
  onInquiry: () => void;
  onReset: () => void;
}

export function ListInquiryFooterButtonGroup({ onInquiry, onReset }: ListInquiryFooterButtonGroupProps) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('inquiry')} onClick={onInquiry} />
      <Button label={getButtonName('reset')} onClick={onReset} />
    </ButtonGroup>
  );
}
